import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class ConsultaConveniosInstrumentosCongeneresService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicioInicio: filtro.exercicioInicial ? filtro.exercicioInicial : null,
            exercicioFim: filtro.exercicioFinal ? filtro.exercicioFinal : null,
            codigoInicio: filtro.codigoInicial ? filtro.codigoInicial : null,
            codigoFim: filtro.codigoFinal ? filtro.codigoFinal : null,
            assinaturaInicio: filtro.assinaturaInicial ? filtro.assinaturaInicial : null,
            assinaturaFim: filtro.assinaturaFinal ? filtro.assinaturaFinal : null,
            tipo: filtro.tipo ? filtro.tipo.map(e => e.value).join() : null,
            unidadeGestora: filtro.unidadeGestora ? filtro.unidadeGestora : null,
            convenente: filtro.convenente ? filtro.convenente : null,
            concedente: filtro.concedente ? filtro.concedente : null,
            interveniente: filtro.interveniente ? filtro.interveniente : null,
            observacao: filtro.objeto ? filtro.objeto : null,
            situacao: filtro.situacao ? filtro.situacao.value : null,
            exercicioLicitacaoInicio: filtro.exercicioLicitacaoInicial ? filtro.exercicioLicitacaoInicial : null,
            exercicioLicitacaoFim: filtro.exercicioLicitacaoFinal ? filtro.exercicioLicitacaoFinal : null,
            numeroLicitacaoIni: filtro.numeroLicitacaoInicial ? filtro.numeroLicitacaoInicial : null,
            numeroLicitacaoFim: filtro.numeroLicitacaoFinal ? filtro.numeroLicitacaoFinal : null,
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            modalidadeLicitacao: filtro.modalidadeLicitacao ? filtro.modalidadeLicitacao.map(e => e.value).join() : null,
            identificacaoExterna: filtro.identificacaoExterna ? filtro.identificacaoExterna : null,
        }

        return this.conex.post(urlConsultaDiarias + 'consultaConveniosInstrumentosCongeneres/', JSON.stringify(data))
    }
}

export default ConsultaConveniosInstrumentosCongeneresService
